<template>
  <FaIcon icon="code-branch" />
</template>

<script setup lang="ts">
</script>
